import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchResults: [],
  searchTerm: "",
  loading: false,
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearSearch: (state) => {
      state.searchTerm = "";
      state.searchResults = [];
    },
  },
});

export const { setSearchTerm, setSearchResults, setLoading, clearSearch } =
  searchSlice.actions;

export const selectSearchResults = (state) => state.search.searchResults;
export const selectSearchTerm = (state) => state.search.searchTerm;
export const selectLoading = (state) => state.search.loading;

export default searchSlice.reducer;
